import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearBookingID, setBookingID } from "./bookingSlice";
import { FiEdit } from "react-icons/fi";
import { checkAcessRights, formatIndianNumber } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  EXCEL_EXPORT_ACCESS,
  INSERT_ACCESS,
  PRINT_ACCESS,
} from "../../_contstants/common";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import {
  deleteBooking,
  getAllBookings,
  sendBookingDetailByEmail,
} from "./services/booking.services";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import moment from "moment";
import { Button } from "@progress/kendo-react-buttons";
import { FaEye } from "react-icons/fa";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { IoIosMail } from "react-icons/io";

const Booking: React.FC = () => {
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const isExcelExportAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS,
  );
  const _export = React.useRef<ExcelExport | null>(null);
  const excelExport = () => {
    if (_export.current !== null) {
      _export.current.save();
    }
  };

  const handleCreate = () => {
    navigate("/booking/create");
  };
  return (
    <>
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Booking List
          </Typography.h4>
          <div>
            {isExcelExportAccess && (
              <Button
                title="Export Excel"
                themeColor={"primary"}
                type="button"
                onClick={excelExport}
                style={{ marginRight: 10 }}
              >
                Export to Excel
              </Button>
            )}
            {isAddAccess && (
              <Button
                // onClick={() => handleCreate(QuotationID)}
                onClick={() => {
                  handleCreate();
                }}
                fillMode={"solid"}
                themeColor={"primary"}
              >
                {"Add New"}
              </Button>
            )}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <BookingGridComponent ref={_export} />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const BookingGridComponent = ({ ref }: { ref: any }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const isPrintAccess = checkAcessRights(location.pathname, PRINT_ACCESS);
  // const isEmailAccess = checkAcessRights(location.pathname, EMAIL_ACCESS);

  const BookingList = useAppSelector((state) => state.booking.BookingList);
  const loading = useAppSelector((state) => state.booking.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  useEffect(() => {
    const payload = {
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllBookings(payload));
  }, [currentPage, pageLimit]);

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(setCurrentPage(0));
    };
  }, []);

  const MyEditCommandCell = (props: any) => {
    const handleEditBooking = (BookingNo: string) => {
      navigate("/booking/edit", {
        state: { BookingNo: BookingNo },
      });
    };
    const handleViewDialog = (BookingNo: number) => {
      window.open(`/booking/view/${BookingNo}/`);
    };

    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteBooking"));
      dispatch(setBookingID(ID));
    };

    const handleSendEmail = async (ID: number) => {
      if (ID) {
        dispatch(openDialog("emailConfirmationDialog"));
        dispatch(setBookingID(ID));
      }
    };

    return (
      <td
        {...props.tdProps}
        className={`action-td ${props.className}`}
        style={props.tdProps.style}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            onClick={() => handleEditBooking(props.dataItem.BookingNo)}
            icon={FiEdit}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "20px" }}
          />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            className="color-red"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
            icon={MdDelete}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {isPrintAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            themeColor="tertiary"
            size="small"
            title="View"
            onClick={() => handleViewDialog(props.dataItem.BookingNo)}
            icon={FaEye}
            iconClassName="absolute-position"
            iconStyle={{ fontSize: "24px" }}
          />
        )}
        {/* {isEmailAccess && ( */}
        {/* Pareshsir told me to that its not necessary to check Email rights for this send Mail */}
        <IconButton
          type="button"
          fillMode="flat"
          size="small"
          title="Send Email"
          themeColor="success"
          onClick={() => handleSendEmail(props.dataItem?.ID)}
          icon={IoIosMail}
          iconClassName="absolute-position"
          iconStyle={{ fontSize: "24px" }}
        />
        {/* )} */}
      </td>
    );
  };

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };
  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${props.index === 11 ? "locked-header" : ""}`}
    >
      {props.children}
    </HeaderThElement>
  );
  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };
  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const gridRef = useRef<any>(null);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <DeleteBookingDialog />
      <EmailConfirmationDialog />
      <ExcelExport
        data={BookingList}
        ref={ref}
        fileName={`Booking_list_${moment().format("DD-MM-YYYY hh-mm A")}.xlsx`}
      >
        <KendoGrid
          style={{ maxHeight: "calc(100vh - 152px)" }}
          className="responsive-table"
          filterable={true}
          filter={filter}
          data={filter ? filterBy(BookingList, filter) : BookingList}
          onFilterChange={handleFilterChange}
          skip={currentPage * pageLimit}
          take={pageLimit}
          total={BookingList[0]?.ItemCount || BookingList?.length}
          pageable={{
            buttonCount: 5,
            pageSizes: [10, 25, 50, 100, 500],
            pageSizeValue: pageLimit,
            type: "input",
          }}
          onPageChange={pageChange}
          cells={{
            headerCell: HeaderCustomCell,
            data: MyDataCustomCell,
          }}
        >
          <Column
            field="BookingNo"
            title="Booking No."
            width={200}
            cells={{
              data: (props: any) => (
                <td>
                  {isPrintAccess ? (
                    <div
                      className="hoverableName"
                      onClick={() =>
                        window.open(
                          `/booking/view/${props.dataItem.BookingNo}/`,
                        )
                      }
                    >
                      {props.dataItem.BookingNo}
                    </div>
                  ) : (
                    <div className="normalName">{props.dataItem.BookingNo}</div>
                  )}
                </td>
              ),
            }}
          />
          <Column field="TravelDate" title="Travel Date" width={150} />
          <Column
            field="Name"
            title="Customer Name"
            width={150}
            cells={{
              data: (props: any) => (
                <td>
                  {props.dataItem?.FirstName} {props.dataItem?.LastName}
                </td>
              ),
            }}
          />
          <Column field="MobileNo" title="Mobile No." width={150} />
          <Column
            field="EmailID"
            title="Email ID"
            width={250}
            cells={{
              data: (props: any) => (
                <td className="text-break">{props.dataItem?.EmailID}</td>
              ),
            }}
          />
          <Column field="TourName" title="Tour" width={200} />
          <Column field="SectorName" title="Sector" width={150} />
          <Column
            field="Duration"
            title="Duration"
            width={120}
            cells={{
              data: (props: any) => (
                <td className="text-center">
                  {+props.dataItem?.NoOfNights || 0}N /{" "}
                  {+props.dataItem?.NoOfDays || 0}D
                </td>
              ),
            }}
          />
          <Column
            field="TotalPax"
            title="Total Pax"
            width={120}
            cells={{
              data: (props: any) => (
                <td className="text-center">{+props.dataItem?.TotalPax}</td>
              ),
            }}
          />
          <Column
            field="TotalAmt"
            title="Total Amount"
            width={150}
            cells={{
              data: (props: any) => (
                <td
                  {...props.tdProps}
                  className={`${props.className} text-end`}
                  style={props.tdProps.style}
                >
                  {formatIndianNumber(+props.dataItem?.TotalAmt || 0)}
                </td>
              ),
            }}
            // locked={true}
          />
          <Column
            field="AgentName"
            title="Agent"
            width={150}
            // cells={{
            //   data: (props: any) => (
            //     <td
            //       {...props.tdProps}
            //       className={`${props.className} text-end`}
            //       style={props.tdProps.style}
            //     >
            //       {formatIndianNumber(+props.dataItem?.TotalAmt || 0)}
            //     </td>
            //   ),
            // }}
            // locked={true}
          />
          {/* Pareshsir told me to that its not necessary to check Email rights for this send Mail */}
          {/* {(isEditAccess ||
            isDeleteAccess ||
            isPrintAccess ||
            isEmailAccess) && ( */}
          <Column
            field=""
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"170px"}
            filterable={false}
            locked={true}
          />
          {/* )} */}
        </KendoGrid>
      </ExcelExport>
    </>
  );
};

const DeleteBookingDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector((state) => state.booking.loading);
  const BookingID = useAppSelector((state) => state.booking.BookingID);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteBooking(ID));
      const payload = {
        limit: +pageLimit,
        skip: +currentPage * +pageLimit,
      };
      if (response.payload.Data.Status === 200) {
        dispatch(getAllBookings(payload));
        dispatch(closeDialog());
        dispatch(clearBookingID());
      } else {
        dispatch(getAllBookings(payload));
        dispatch(closeDialog());
        dispatch(clearBookingID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteBooking" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Booking"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Booking ?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(BookingID)}
                  type="button"
                  disabled={loading}
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const EmailConfirmationDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const BookingID = useAppSelector((state) => state.booking.BookingID);
  const loading = useAppSelector((state) => state.booking.loading);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const gridRef = useRef<any>(null);

  const handleConfirm = async (ID: number | null) => {
    if (ID) {
      const res = await dispatch(sendBookingDetailByEmail({ ID: +ID }));
      if (res.meta.requestStatus === "fulfilled") {
        dispatch(closeDialog());
      }
    }
  };

  return (
    <>
      {dialogName === "emailConfirmationDialog" && (
        <AppDialog>
          <>
            {loading && <LoadingPanel gridRef={gridRef} />}
            <Typography.h5>{"Email Confirmation"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to send Email?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="primary" />
                <Button
                  fillMode={"solid"}
                  themeColor={"primary"}
                  onClick={() => handleConfirm(BookingID)}
                  type="button"
                >
                  Confirm
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default Booking;
